/* Dansk katalog for locale-invoice-list-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'listControl.dialog': 'Luk den åbne dialog, før chatten fortsætter med fakturalisten.',
  'live.set_document_type': 'Vælger dokumenttype …',
  'listControl.alreadyDone': 'Handlingen er allerede udført for dette dokument i denne anmodning.',
  'listControl.choice.attachment': 'PDF-vedhæftning',
  'listControl.choice.link': 'Link',
  'listControl.choice.reminder': 'Betalingspåmindelse',
  'listControl.choice.purring': 'Rykker',
  'listControl.working': 'Arbejder med fakturalisten …',
  'listControl.unavailable': 'Fakturalisten er ikke klar. Åbn siden, og prøv igen.',
  'listControl.selection': 'Vælg entydige dokumenter fra søgeresultatet, højst 20 ad gangen.',
  'listControl.changed': 'Listen eller udvalget er ændret. Søg, og vælg dokumenterne igen.',
  'listControl.invalid': 'Handlingen mangler gyldige detaljer.',
  'listControl.ineligible': 'Denne handling passer ikke til alle valgte dokumenter.',
  'listControl.reason': 'Angiv årsagen til krediteringen.',
  'listControl.reminder': 'Vælg en ubetalt faktura, type påmindelse og ny forfaldsdato. Afsendelsen er uden gebyr.',
  'listControl.payment': 'Angiv beløb inden for det udestående, betalingsdato og betalingskonto for én faktura.',
  'listControl.conversion': 'Vælg et færdigt tilbud uden tidligere konverteringer. Brug Opret på siden, hvis du har brug for en ekstra konvertering.',
  'listControl.uncertain': 'Resultatet er ikke bekræftet. Kontrollér dokumentet før et nyt forsøg; chatten prøver ikke automatisk igen.',
  'listControl.unsaved': 'Gem eller luk den åbne kladde, før du skifter dokument.',
  'listControl.stopped': 'Resten af udvalget blev ikke udført.',
  'listControl.done.searched': 'Søgningen vises i fakturalisten.',
  'listControl.done.selected': 'Dokumenterne er valgt på listen.',
  'listControl.done.opened': 'Dokumentet er åbnet.',
  'listControl.done.unsaved': 'Kladden er åbnet og er ikke gemt endnu.',
  'listControl.done.prepared': 'Handlingen og detaljerne vises nedenfor.',
  'listControl.done.sent': 'Sendt.',
  'listControl.done.paid': 'Betalingen er registreret.',
  'listControl.done.deleted': 'Kladden er slettet.',
  'listControl.done.archived': 'Arkiveret.',
  'listControl.done.restored': 'Hentet fra arkivet.',
  'listControl.done.creditDraft': 'Kreditnotaen er gemt som kladde.',
  'listControl.done.issued': 'Dokumentet er oprettet.',
  'listControl.operation.send': 'Send dokumenter',
  'listControl.operation.reminder': 'Send påmindelse / rykker uden gebyr',
  'listControl.operation.credit': 'Kreditér',
  'listControl.operation.archive': 'Arkivér',
  'listControl.operation.restore': 'Hent fra arkivet',
  'listControl.operation.delete_draft': 'Slet kladder',
  'listControl.operation.register_payment': 'Registrér betaling',
  'listControl.operation.issue_draft': 'Opret dokument',
  'listControl.option.recipientEmail': 'Modtager',
  'listControl.option.deliveryMode': 'Leveringsmåde',
  'listControl.option.variant': 'Type',
  'listControl.option.dueDate': 'Forfaldsdato',
  'listControl.option.comment': 'Kommentar',
  'listControl.option.creditReason': 'Årsag',
  'listControl.option.issue': 'Opret færdig kreditnota',
  'listControl.option.amount': 'Beløb',
  'listControl.option.date': 'Betalingsdato',
  'listControl.option.settlementAccountCode': 'Betalingskonto',
  'listControl.option.note': 'Note',
  'live.done.set_document_type': 'Dokumenttypen er valgt.',
});
